import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SelectedEmployeeProvider } from './context/SelectedEmployeeContext';
import ProtectedRoute from './components/ProtectedRoute';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const LeavePage = lazy(() => import('./pages/LeavePage'));

function LoadingFallback() {
  return (
    <div className="loader" style={{ minHeight: '100vh' }}>
      <div className="spinner"></div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SelectedEmployeeProvider>
        <Router>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <ProfilePage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leaves"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <LeavePage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Suspense>
        </Router>
      </SelectedEmployeeProvider>
    </AuthProvider>
  );
}
